module.exports = __webpack_public_path__ + "static/img/lock_v.7878fdd6.svg";